export const forDevelopers = `
## 開発者の方へ

FurPortはオープンソースプロジェクトです。バグ報告や機能追加リクエストをはじめとしたイシューやプルリクエストを歓迎しています！是非下記Githubリポジトリよりコントリビューションをお待ちしています。

- [FurPortフロントエンドリポジトリ](https://github.com/lapi-hotel-group/furport-front)
- [FurPortバックエンドリポジトリ](https://github.com/lapi-hotel-group/furport-back)
`;
